/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Bearbeiten",
  "i18n.actionBar.removeImage": "Entfernen",
  "i18n.actionBar.swapImage": "Tauschen",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NEU!",
  "i18n.additionalProducts.addToCart": "Der Bestellung hinzufügen",
  "i18n.additionalProducts.frame.description": "Hochwertiger Aluminiumrahmen: silber matt, Premium-Echtglas, kein Kleber nötig",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tipp:",
  "i18n.additionalProducts.frame.subtitle": "Das fertige Puzzle ist ein tolles Erinnerungsstück – mit unserem <b>Rahmen</b> einfach perfekt in Szene gesetzt.",
  "i18n.additionalProducts.frame2023.description": "Hochwertiger Holzfaserrahmen – einfach montiert, ohne Glas, inkl. Puzzlekleber",
  "i18n.additionalProducts.framePlastic.description": "Hochwertiger Aluminiumrahmen: silber matt, entspiegeltes Kunstglas, kein Kleber nötig",
  "i18n.additionalProducts.glue.description": "Für bis zu zwei 1000-Teile-Puzzles, inkl. Auftragsschwamm",
  "i18n.additionalProducts.glue.hook": "Damit aus deinem Puzzle ein Bild wird.\nVerklebt und schützt dauerhaft.",
  "i18n.additionalProducts.roll.description": "Für Puzzles von 48 bis 2000 Teilen",
  "i18n.additionalProducts.roll.hook": "Kein freier Tisch? Kein Problem.\nPuzzle einrollen, verstauen und später weitermachen.",
  "i18n.adventCalendarOverlay.activate": "24-Türchen-Vorschau einblenden",
  "i18n.adventCalendarOverlay.deactivate": "24-Türchen-Vorschau ausblenden",
  "i18n.adventCalendarOverlay.notice": "(die Zahlen und Linien werden nicht mitgedruckt)",
  "i18n.button.addToCart": "In den Warenkorb",
  "i18n.button.apply": "Übernehmen",
  "i18n.button.back": "Zurück",
  "i18n.button.cancel": "Abbrechen",
  "i18n.button.cancelAndFix": "Jetzt anpassen",
  "i18n.button.chooseSmartSorted": "SMART SORTED auswählen",
  "i18n.button.close": "Schliessen",
  "i18n.button.continue": "Weiter",
  "i18n.button.createNewTextPlaceholders": "Text eingeben",
  "i18n.button.ignore": "Ignorieren",
  "i18n.button.ignoreAndContinue": "Trotzdem weiter",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "keine Änderung",
  "i18n.button.ok": "Verstanden!",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Erneut versuchen",
  "i18n.button.uploadPhotos": "Fotos hochladen",
  "i18n.button.withSmartSorted": "Mit SMART SORTED",
  "i18n.button.withoutSmartSorted": "Ohne SMART SORTED",
  "i18n.control.colorChooser.color": "Farbe",
  "i18n.control.fontChooser.placeholderText": "Schriftart",
  "i18n.control.imageQuality.checkImages": "Bilder prüfen",
  "i18n.control.imageQuality.imageSuitability": "Bildqualität:",
  "i18n.control.imageQuality.indicatorAltText": "Bildqualität",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Design wählen",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Für bessere Lesbarkeit bitte Textlänge / Zeilenlänge kürzen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Die gewählte Schriftart ist zu gross für diesen Text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Die maximal mögliche Schriftgrösse für diesen Text wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Die minimal mögliche Schriftgrösse wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Bitte Zeilenumbruch einfügen.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Bitte Zeilenumbruch einfügen oder Textfeld vergrössern.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Bitte überprüfe Deine Eingaben, nicht alle Zeichen werden von dieser Schriftart unterstützt.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Die maximale Anzahl an Zeichen ist erreicht.",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Die maximale Anzahl an Zeilen ist erreicht.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Bitte Textfeld vergrössern.",
  "i18n.dialog.deletePlaceholder.message": "Dieser Schritt kann nicht rückgängig gemacht werden.",
  "i18n.dialog.deletePlaceholder.title": "Platzhalter wirklich löschen?",
  "i18n.dialog.error.title": [
    "Es ist ein Fehler aufgetreten",
    "Es sind Fehler aufgetreten"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Die Auflösung dieses Bildes ist zu gering, um das Motiv optimal zu drucken!",
  "i18n.dialog.smartSorted.message": "Mit SMART SORTED puzzelt Ihr innovativ und mühelos euer Motiv mit 1000 Teilen auch ohne Motiv-Vorlage",
  "i18n.dialog.smartSorted.title": "Puzzle-Erfolgserlebnis garantiert",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Bitte klicke auf „{{text}}“, um den Titel Deinen Wünschen anzupassen.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Der Schachteltitel wurde nicht geändert.",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Weiter ohne Text",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Bitte füge per Klick auf den Bildplatzhalter Dein Foto ein.",
    "Bitte füge per Klick auf die Bildplatzhalter Deine Fotos ein."
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Ein Bildplatzhalter wurde nicht gefüllt.",
    "Mehrere Bildplatzhalter wurden nicht gefüllt."
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Ein Platzhalter wurde nicht geändert.",
    "Mehrere Platzhalter wurden nicht geändert."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Bitte klicke auf die Bild- und Text-Platzhalter um das Design Deinen Wünschen anzupassen.",
    "Bitte klicke auf die Bild- und Text-Platzhalter um das Design Deinen Wünschen anzupassen."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Es wurden mehrere Platzhalter nicht geändert.",
    "Es wurden mehrere Platzhalter nicht geändert."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Bitte klicke auf das Textfeld, um den Text Deinen Wünschen anzupassen.",
    "Bitte klicke auf die Textfelder, um die Texte Deinen Wünschen anzupassen."
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Ein Textfeld wurde nicht geändert.",
    "Mehrere Textfelder wurden nicht geändert."
  ],
  "i18n.dialog.unchangedPlaceholders.title": "unveränderte Platzhalter",
  "i18n.error.additionalInfoItemsError.message": "Ein Informationslayer konnte nicht geladen werden.",
  "i18n.error.additionalInfoItemsError.title": "Ladefehler",
  "i18n.error.deprecatedBrowserError.message": "Dein verwendeter Browser wird nicht mehr unterstützt. Bitte aktualisiere auf eine neuere Version.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Du hast die Gestaltung für längere Zeit unterbrochen. Sie kann nicht fortgeführt werden. Bitte starte den Vorgang erneut.",
  "i18n.error.designerExpiredError.title": "Gestaltung beendet",
  "i18n.error.fontLoadingError.message": "Eine Schriftart konnte nicht geladen werden.",
  "i18n.error.fontLoadingError.title": "Ladefehler",
  "i18n.error.imageLoadingError.message": "Ein Bild konnte nicht geladen werden.\nEs wurde aus der Galerie und der Gestaltungsfläche entfernt.",
  "i18n.error.imageLoadingError.title": "Ladefehler",
  "i18n.error.imageProvisionError.message": "Ein oder mehrere Bilder konnte nicht verarbeitet werden. Möglicherweise wird das Format nicht unterstützt.",
  "i18n.error.imageProvisionError.title": "Ein Bild konnte nicht verarbeitet werden",
  "i18n.error.imageSelectionError.message": "Die Datei „{{reference1}}“ konnte nicht verarbeitet werden.",
  "i18n.error.imageSelectionError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageSizeLimitExceededError.message": "Das von Dir hochgeladene Bild hat zu grosse Abmessungen.\nAus technischen Gründen können wir es nicht verarbeiten.\nBitte verkleinere das Bild auf weniger als 180 Megapixel und lade es erneut hoch.",
  "i18n.error.imageSizeLimitExceededError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageUploadError.message": "Es scheint ein Problem mit der Internetverbindung zu geben.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.imageUploadError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.inlineSVGLoadingError.message": "Der Toleranzrahmen „{{reference1}}“ konnte nicht geladen werden.",
  "i18n.error.inlineSVGLoadingError.title": "Ladefehler",
  "i18n.error.invalidCharConfigError.message": "Die Schriftart ist fehlerhaft und kann nicht verwendet werden.",
  "i18n.error.invalidCharConfigError.title": "Fehlerhafte Schriftart",
  "i18n.error.malformedProductError.message": "Ein oder mehrere Produkte konnten nicht auf den Server übertragen werden. Möglicherweise ist das Produkt nicht mehr verfügbar oder die Produktgestaltung hat zu lange gedauert.\n\nDas tut uns leid. Bitte beginne die Gestaltung erneut.",
  "i18n.error.malformedProductError.title": "Produktfehler",
  "i18n.error.notInStockError.message": "Das von dir gewählte Produkt ist derzeit leider nicht verfügbar.\nÜber unser Logo links oben gelangst du zur Startseite. Dort kannst du ein anderes Produkt auswählen.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Deine Internetverbindung scheint unterbrochen zu sein. Du kannst mit der Gestaltung fortfahren, sobald die Verbindung wieder hergestellt wurde.",
  "i18n.error.templateLoadingError.message": "Das Template „{{ error.reference[0] }}“ konnte nicht geladen werden.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.templateLoadingError.title": "Ladefehler",
  "i18n.error.transformationError.message": "Die Transformation konnte nicht angewendet werden.",
  "i18n.error.transformationError.title": "Transformationsfehler",
  "i18n.error.traudlLoadingError.message": "Bitte versuche es erneut oder verwende ein anderes Bild.",
  "i18n.error.traudlLoadingError.title": "Ein AI-Filter konnte nicht angewendet werden.",
  "i18n.error.unsupportedMediaTypeError.message": "Nicht unterstütztes Bildformat für „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.uploadProductError.message": "Ein oder mehrere Produkte konnten nicht auf den Server übertragen werden.\nMöglicherweise liegt ein Problem mit der Internetverbindung vor.",
  "i18n.error.uploadProductError.title": "Übertragungsfehler",
  "i18n.error.zoomModeError.message": "Dein Text aus dem vorherigen Design konnte nicht übernommen werden und wurde zurückgesetzt.",
  "i18n.error.zoomModeError.title": "Text nicht übernommen",
  "i18n.gallery.uploadPhotos.info": "Bitte klicke auf den Button „Fotos hochladen“",
  "i18n.gallery.uploadProgress": [
    "Foto wird hochgeladen",
    "{{current}} von {{total}} Fotos hochgeladen"
  ],
  "i18n.price.price": "Preis",
  "i18n.price.reduction": "Du sparst",
  "i18n.price.total": "Gesamtpreis",
  "i18n.priceDisplay.times": [
    "{{value}} Stück à {{pricePerUnit}}",
    "{{value}} Stück à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Zubehör (optional)",
  "i18n.progressOverlay.message.lines.one": "Danke für die schöne Gestaltung.",
  "i18n.progressOverlay.message.lines.two": "Wir bereiten alles für Dich vor...",
  "i18n.template.insertText": "Hier Text eingeben",
  "i18n.toolbox.gallery.title": "Fotos wählen",
  "i18n.toolbox.image.title": "Bild bearbeiten",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 Bild",
    "{{value}} Bilder"
  ],
  "i18n.toolbox.layout.title": "Design wählen",
  "i18n.toolbox.layout.triggerText": "Designs",
  "i18n.toolbox.preview.title": "3D Vorschau",
  "i18n.toolbox.productChooser.title": "Produkt wechseln",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Text bearbeiten"
};


export class LocaleDeCH {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
